import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');

  // Data profile host dengan properti showSocial untuk kontrol tampilan
  const hosts = [
    {
      id: 1,
      userId: "2086132",
      name: "KING HAN",
      role: "OWNER MANAGEMENT",
      experience: "5+ Years",
      rating: 4.9,
      description: "Spesialis dalam manajemen event dan koordinasi tim. Berpengalaman menangani berbagai acara skala besar.",
      photo: "https://i.ibb.co.com/WNyQmxbD/IMG-20260208-WA0002.jpg",
      social: {
        instagram: "KINGHAN44",
        whatsapp: "+62811248168",
        email: "crownmanagement44@gmail.com"
      },
      showSocial: true // Set true untuk menampilkan, false untuk menyembunyikan
    },
    {
      id: 2,
      userId: "3295355",
      name: "SUGAR BABY",
      role: "Technical Host",
      experience: "4+ Years",
      rating: 4.2,
      description: "Together, we can achieve greatness. Let's make it happen!🚀",
      photo: "https://i.ibb.co.com/V8zqQ9w/IMG-20260208-193450.jpg",
      social: {
        instagram: "bagas_samuji74",
        whatsapp: "+6287710528400",
        email: "Lianadwitasari466@gmail.com"
      },
      showSocial: false // Set false untuk menyembunyikan tombol sosial
    },
   {
     id:3,
     userId: "2077731",
     name: "Xiaolin",
     role: "Technical Host",
     experience: "4+ Years",
     rating: 4.2,
     description: "Together, we can achieve greatness. Let's make it happen!🚀",
     photo: "https://i.ibb.co.com/ccW1gvNp/momo-20260209-021434-911.jpg",
     social: {
        instagram: "",
        whatsapp: "+",
        email: ""
      },
      showSocial: false // Set false untuk menyembunyikan tombol sosial
    },
  ];

  // Fungsi untuk kembali ke halaman utama
  const handleBackToHome = () => {
    navigate('/');
  };

  // Filter hosts berdasarkan role
  const filteredHosts = activeTab === 'all' 
    ? hosts 
    : hosts.filter(host => host.role.toLowerCase().includes(activeTab.toLowerCase()));

  return (
    <div className="profile-page">
      {/* Header */}
      <header className="profile-header">
        <button className="back-button" onClick={handleBackToHome}>
          <i className="fas fa-arrow-left"></i>
          Kembali
        </button>
        <div className="profile-title">
          <h1><i className="fas fa-crown"></i> Profile Host</h1>
          <p>Tim profesional yang siap membantu Anda</p>
        </div>
      </header>

      {/* Tabs Filter */}
      <div className="profile-tabs">
        <button 
          className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
          onClick={() => setActiveTab('all')}
        >
          <i className="fas fa-users"></i> Semua Host
        </button>
        <button 
          className={`tab-btn ${activeTab === 'lead' ? 'active' : ''}`}
          onClick={() => setActiveTab('lead')}
        >
          <i className="fas fa-star"></i> Lead Host
        </button>
        <button 
          className={`tab-btn ${activeTab === 'coordinator' ? 'active' : ''}`}
          onClick={() => setActiveTab('coordinator')}
        >
          <i className="fas fa-calendar-alt"></i> Coordinator
        </button>
        <button 
          className={`tab-btn ${activeTab === 'technical' ? 'active' : ''}`}
          onClick={() => setActiveTab('technical')}
        >
          <i className="fas fa-tools"></i> Technical
        </button>
      </div>

      {/* Host Cards Grid */}
      <div className="hosts-grid">
        {filteredHosts.map(host => (
          <div key={host.id} className="host-card">
            <div className="host-card-header">
              <div className="host-photo">
                <img src={host.photo} alt={host.name} />
                <div className="host-badge">
                  <i className="fas fa-crown"></i>
                </div>
              </div>
              <div className="host-info">
                <h3>{host.name}</h3>
                <div className="host-userid">
                  <i className="fas fa-id-card"></i>
                  <span>ID: {host.userId}</span>
                </div>
                <div className="host-role">
                  <i className="fas fa-briefcase"></i>
                  <span>{host.role}</span>
                </div>
              </div>
            </div>
            
            <div className="host-card-body">
              <p className="host-description">{host.description}</p>
              
              <div className="host-stats">
                <div className="stat">
                  <i className="fas fa-clock"></i>
                  <span>Pengalaman: {host.experience}</span>
                </div>
                <div className="stat">
                  <i className="fas fa-star"></i>
                  <span>Rating: {host.rating}/5.0</span>
                </div>
              </div>
            </div>

            {/* Tombol sosial hanya ditampilkan jika showSocial = true */}
            {host.showSocial && (
              <div className="host-card-footer">
                <div className="host-social">
                  <a 
                    href={`https://wa.me/${host.social.whatsapp}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-btn whatsapp"
                  >
                    <i className="fab fa-whatsapp"></i>
                    WhatsApp
                  </a>
                  <a 
                    href={`mailto:${host.social.email}`}
                    className="social-btn email"
                  >
                    <i className="fas fa-envelope"></i>
                    Email
                  </a>
                  <a 
                    href={`https://instagram.com/${host.social.instagram}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-btn instagram"
                  >
                    <i className="fab fa-instagram"></i>
                    Instagram
                  </a>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Team Stats Section */}
      <div className="team-stats">
        <div className="stat-card">
          <i className="fas fa-users"></i>
          <h3>{hosts.length}+</h3>
          <p>Host Professional</p>
        </div>
        <div className="stat-card">
          <i className="fas fa-calendar-check"></i>
          <h3>100+</h3>
          <p>Event Berhasil</p>
        </div>
        <div className="stat-card">
          <i className="fas fa-star"></i>
          <h3>4.8</h3>
          <p>Rating Rata-rata</p>
        </div>
        <div className="stat-card">
          <i className="fas fa-smile"></i>
          <h3>98%</h3>
          <p>Kepuasan Klien</p>
        </div>
      </div>

      {/* CTA Section */}
      <div className="profile-cta">
        <h2>Ingin Bekerja Sama dengan Tim Kami?</h2>
        <p>Hubungi kami untuk konsultasi gratis dan perencanaan event Anda</p>
        <button 
          className="cta-button"
          onClick={() => window.open('https://wa.me/62811248168', '_blank')}
        >
          <i className="fab fa-whatsapp"></i>
          Hubungi via WhatsApp
        </button>
      </div>

      {/* Footer */}
      <footer className="profile-footer">
        <div className="footer-logo">
          <i className="fas fa-crown"></i>
          <span>CROWN MANAGEMENT</span>
        </div>
        <p className="copyright">© 2026 CROWN MANAGEMENT - All Rights Reserved</p>
      </footer>
    </div>
  );
};

export default Profile;
